// import "vite/dynamic-import-polyfill";

import '../../_shared/common';
import '../../_shared/search';
import '../../_shared/search/index_map';
import '../../_shared/popups/lead_popup_post_requirements';
import './city.css';
import { setupNetworkSlider } from '../home/network-slider';
import '../home/network-slider.css';
window.addEventListener('slick-ready', () => {
    setupNetworkSlider();
});

window.Page = window.Page || {};
let Page = window.Page;
Page.baseUrl = window.hydrateJSON.baseUrl;
Page.cloudFrontUrl = window.hydrateJSON.cloudFrontUrl;
Page.filters = [];
Page.filters.resourceTypes = [];
Page.pageSize = 6;
getResourceTypeFilters();

window.change_option = function (ipt) {
    var ipt_id = ipt.id;
    var ipts = ['private_office', 'desks', 'meeting_room', 'virtual_office'];
    for (var nv = 0; nv < ipts.length; nv++) {
        if (
            ipt_id != 'ipt_' + ipts[nv] &&
            $('#ipt_' + ipts[nv]).is(':checked')
        ) {
            $('#ipt_' + ipts[nv]).prop('checked', false);
        }
    }
    storeResourceTypeFilters();
};

window.search_option = function () {
    var ipt_search = $('#myInput').val().trim();
    var ipt_duration = $('#ipt_duration').val().trim();
    var ipt_pax = $('#select_pax').val();
    $('#search_error').hide();
    $('#duration_error').hide();
    $('#pax_error').hide();

    if (ipt_search == '') {
        $('#search_error').show();
    }

    if (ipt_duration == '') {
        $('#duration_error').show();
    }

    if (ipt_pax == '') {
        $('#pax_error').show();
    }
};

function storeResourceTypeFilters() {
    var values = [];
    $('[name="resource_types"]:checked').each( (index, el) => {
        values.push( $(el).val() );
    } )
    window.localStorage.setItem( 'resourceTypeFilters', JSON.stringify(values) );
}

function getResourceTypeFilters() {
    var items = JSON.parse( window.localStorage.getItem( 'resourceTypeFilters' ) );
    if ( items === null ) {
        // this has to be on production and staging
        return;
    }
    $('[name="resource_types"]').each( (index, el) => {
        if ( items.indexOf( $(el).val() ) === -1 ) {
            $(el).prop('checked', false);
        } else {
            $(el).prop('checked', true);
        }
    } );
}

$('#search_button').on('click', function (e) {
    e.preventDefault();
    var queryString = '?duration=' + $('#duration').val();

    Page.filters.resourceTypes = [];
    $.each($('input[name="resource_types"]:checked'), function () {
        Page.filters.resourceTypes.push($(this).val());
    });

    if (Page.filters.resourceTypes.length > 0) {
        queryString += '&filter_resource_types=' + Page.filters.resourceTypes;
    }

    var url = window.hydrateJSON.searchUrl + queryString;
    window.location.href = url;
});

// function open_network_city(evt) {
//     var url = this.dataset.url;
//     if (evt.target.nodeName !== 'A') {
//         window.open(url, '_blank');
//     }
// }
// $('.search-space-main-outer').on('click', open_network_city);

$('#price-range-save-button').on('click', function (evt) {
    evt.preventDefault();
    loadSearchResults(1);
});
